import React from 'react'
import './styles.scss'

export default function UsuarioLogado(props) {

    if (!props.usuarioLogado) {
        return null;
    }

    if (!props.usuarioLogado.logado) {
        return null;
    }
    
    return (
        <div className="usuarioLogado">
            Olá, { props.usuarioLogado.nome }
        </div>
    )
}